/** Поддерживаемые языки интерфейса. uz — узбекский в кириллице. */
export const LOCALES = ['ru', 'uz'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'ru';

export function isLocale(v: unknown): v is Locale {
  return typeof v === 'string' && (LOCALES as readonly string[]).includes(v);
}

/**
 * Эффективный язык: явный выбор пользователя, иначе язык Telegram (uz*, ru*), иначе ru.
 * Английский и прочие языки падают в ru — узбекская аудитория в основном двуязычна.
 */
export function resolveLocale(
  preferred: string | null | undefined,
  telegramLanguageCode: string | null | undefined,
): Locale {
  if (isLocale(preferred)) return preferred;
  const code = (telegramLanguageCode ?? '').toLowerCase();
  if (code.startsWith('uz')) return 'uz';
  return DEFAULT_LOCALE;
}
